import axios from "axios";
import { FETCH_DELIVERY_DATES } from "./actionTypes";

export const fetchDeliveryDates = (currentLocation, userId) => (dispatch) => {
  const requestData = {
    location: currentLocation,
    user_id: userId,
  };

  return axios
    .post("/schedule", requestData)
    .then((response) => {
      console.dir(response);
      //Set DeliveryDates Data
      const deliveryDates = response.data.data.schedule[0].delivery_dates;

      //Dispatch Delivery Data
      return dispatch({
        type: FETCH_DELIVERY_DATES,
        payload: deliveryDates,
      });
    })
    .catch((err) => {
      console.log(
        "[deliveryDates.actions.js] DeliveryDates || Could not fetch delivery dates. Try again later."
      );
    });
};

export const getDeliveryInfo = async (locationId, setState) => {
  await axios
    .post("/delivery", {
      location: locationId,
    })
    .then((response) => {
      setState(response.data.data);
    });
};

export const checkPostcode = async (
  postCode,
  houseNumber,
  fetch_adres,
  setPostcodeCorrect,
  setAddressLine,
  setAddressData,
  setPostcodeMessage
) => {
  await axios
    .post("/postcode_check", {
      postcode: postCode,
      number: houseNumber,
      fetch_adres: fetch_adres,
    })
    .then((response) => {
      if (response.data.code == 200) {
        setPostcodeCorrect(true);
        setAddressLine(
          response.data.data.street + ", " + response.data.data.city
        );
        setAddressData(response.data.data);
      }
      setPostcodeMessage(response.data.message);
    });
};

export const getPickupPoints = async (setPickupPoints) => {
  //YOO
  setPickupPoints(null);
  await axios.post("/pickuppoints", {}).then((response) => {
    if (response.data.code == 200) {
      setPickupPoints(response.data.data.pickuppoints);
    }
  });
};
